<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Add Time Server</h4>
      </div>
    </div>

    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label>Server</label>
            <input type="text" class="form-control" v-model="time_server.address">
          </div>
          <br><br>
          <button type="submit" class="btn btn-hub-primary" @click="save()">Submit</button>
          <router-link :to="{ name: 'AdminMachineTimeServerIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'timeServerAdd',
  data: function () {
    return {
      time_server: {
        'address': ''
      }
    }
  },
  methods: {
    save () {
      this.$store.dispatch('addTimeServer', this.time_server)
    }
  }
}
</script>

<style scoped>

</style>
